import { api } from 'components/api'
import { surveyResponsesPath } from 'components/routes/api'
import {
  toSurveyResponseData,
  type ApiSurveyResponseResponse,
  type SurveyResponseData
} from 'components/surveys/responses/services/surveyResponseData'

interface CreateSurveyResponsePayload {
  survey_id: string
  review_id?: number
}

interface CreateSurveyResponseParams {
  surveyId: string
  reviewId?: number
}

export const createSurveyResponse = async ({
  surveyId,
  reviewId
}: CreateSurveyResponseParams): Promise<SurveyResponseData> => {
  const data: CreateSurveyResponsePayload = {
    survey_id: surveyId,
    ...(reviewId !== undefined && { review_id: reviewId })
  }

  const response = await api.postWithCsrf<CreateSurveyResponsePayload, ApiSurveyResponseResponse>({
    url: surveyResponsesPath(),
    headers: { Accept: 'application/json' },
    data
  })

  return toSurveyResponseData(response.data)
}
